@if (!isMobile) {
<h1 #searchHeading class="shrink-0 !mt-0 !mb-1">
  {{ "FIND_WORK" | translate }}
</h1>
}
<div
  class="search-toolbar sticky top-0 mobile:-top-6 z-20 shrink-0 bg-white dark:bg-black-dark mobile:pt-1 pb-0.5 before:pointer-events-none before:absolute before:-inset-x-6 before:-top-[96px] before:bottom-0 before:-z-10 before:bg-white dark:before:bg-black-dark"
  [ngClass]="
    isMobile || stickyToolbarRaised ? 'before:opacity-100' : 'before:opacity-0'
  "
  data-swipe-navigation-ignore
>
  @if (isMobile) {
  <div class="relative -left-0.5 mb-1.5 flex h-[32px] items-center gap-1.5">
    <button
      type="button"
      class="flex h-[32px] w-[32px] shrink-0 cursor-pointer items-center justify-center rounded-full bg-black/50"
      (click)="closeSearch()"
      [attr.aria-label]="'CLOSE_MODAL' | translate"
    >
      <span
        aria-hidden="true"
        class="block h-[20px] w-[20px] rotate-180 bg-white mask-[url(/assets/images/icons/arrow-right.svg)] mask-center mask-no-repeat mask-size-[20px_20px]"
      ></span>
    </button>
    <h1 class="!m-0 !text-[24px] !leading-[32px]">
      {{ "SEARCH" | translate }}
    </h1>
  </div>
  }
  <form
    [formGroup]="searchForm"
    class="relative w-full shrink-0 !mt-0 !mb-0.5"
    (ngSubmit)="runSearch()"
  >
    <input
      class="search !h-[48px] !px-[44px] !mb-0"
      [ngClass]="{'!pr-[80px]': !isMobile && !!searchTerm}"
      type="text"
      inputmode="search"
      formControlName="search"
      (input)="onInputChange($event)"
      [placeholder]="
        (isMobile &&
        !selectedEntities.length &&
        !genreFilters.length &&
        !releaseYearFilters.length
          ? 'CATALOG_SEARCH_PLACEHOLDER_SHORT'
          : searchPresentation.placeholderKey
        ) | translate: searchPresentation.params
      "
      [attr.aria-label]="'SEARCH' | translate"
      #searchInput
    />
    <span
      class="icon !h-[24px] !w-[24px]"
      style="
        mask: url(&quot;/assets/images/icons/search.svg&quot;) center / 24px
          24px no-repeat;
      "
    ></span>
    @if (searchTerm) {
    <button
      [appPointerHover]="!isMobile"
      class="absolute right-[2px] top-[2px] flex h-[44px] cursor-pointer items-center justify-center text-sm text-grey dark:text-borders-dark [&.is-pointer-hovered]:underline focus-visible:underline"
      [ngClass]="isMobile ? 'w-[44px]' : 'w-[72px]'"
      type="button"
      (click)="clearSearch()"
      [attr.aria-label]="'CLEAR_SEARCH' | translate"
    >
      @if (isMobile) {
      <span
        class="h-[16px] w-[16px] bg-black dark:bg-white mask-[url(/assets/images/icons/close.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        aria-hidden="true"
      ></span>
      } @else {
      {{ "CLEAR" | translate }}
      }
    </button>
    }
  </form>
  <div
    class="media-filters flex shrink-0 items-center gap-0.5 overflow-x-auto whitespace-nowrap [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    #mediaFilters
    (scroll)="updateMediaEdges()"
    [style.mask-image]="
      getHorizontalOverflowMask(mediaOverflowStart, mediaOverflowEnd)
    "
    data-swipe-navigation-ignore
    role="group"
    [attr.aria-label]="'CATALOG_SEARCH_MEDIA_FILTERS' | translate"
  >
    <button
      type="button"
      class="min-h-[48px] shrink-0 cursor-pointer py-1 text-sm"
      [attr.aria-pressed]="searchType === null"
      (click)="selectType(null, $event)"
    >
      <span
        class="flex min-h-[32px] items-center gap-0.5 rounded-full px-1.5 transition-colors"
        [ngClass]="
          searchType === null
            ? 'bg-primary/20 font-bold text-black dark:text-white'
            : 'text-grey dark:text-borders-dark hover:bg-black/5 dark:hover:bg-white/5'
        "
      >
        {{ "ALL" | translate }}
      </span>
    </button>
    @for (type of worksTypesArray; track type) {
    <div class="relative shrink-0">
      <button
        type="button"
        class="min-h-[48px] cursor-pointer py-1 text-sm"
        [attr.aria-pressed]="searchType === type"
        (click)="selectType(type, $event)"
      >
        <span
          class="flex min-h-[32px] items-center gap-0.5 rounded-full px-1.5 transition-colors"
          [ngClass]="
            searchType === type
              ? 'bg-primary/20 font-bold text-black dark:text-white'
              : 'text-grey dark:text-borders-dark hover:bg-black/5 dark:hover:bg-white/5'
          "
        >
          {{ worksLabels[type] | translate }}
          @if (isCatalogBetaWorkType(type)) {
          <span
            class="ml-0.5 text-[10px] font-semibold leading-none text-primary-text dark:text-primary"
            >{{ "BETA" | translate }}</span
          >
          }
        </span>
      </button>
    </div>
    }
  </div>
  @if (selectedEntities.length || genreFilters.length ||
  releaseYearFilters.length) {
  <div
    class="mt-1 flex shrink-0 flex-wrap gap-1"
    [attr.aria-label]="'CATALOG_SEARCH_ACTIVE_FILTERS' | translate"
  >
    @for (entity of selectedEntities; track getEntitySuggestionKey(entity)) {
    <button
      type="button"
      class="flex min-w-0 cursor-pointer items-center gap-1 rounded-full border border-primary-text/60 bg-primary/10 px-1.5 py-0.5 text-left text-sm dark:border-primary/60"
      (click)="onEntityToggled(entity)"
      [attr.aria-label]="
        'CATALOG_SEARCH_REMOVE_ENTITY' | translate: {name: entity.name}
      "
    >
      <span
        class="h-[16px] w-[16px] shrink-0 bg-current mask-[url(/assets/images/icons/check.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
        aria-hidden="true"
      ></span>
      <span class="min-w-0 break-words"
        >{{ getEntityRoleLabelKey(entity) | translate }} :
        {{ entity.name }}</span
      >
      <span
        class="h-[16px] w-[16px] shrink-0 bg-current mask-[url(/assets/images/icons/close.svg)] mask-center mask-no-repeat mask-size-[10px_10px]"
        aria-hidden="true"
      ></span>
    </button>
    } @for (genre of genreFilters; track genre) {
    <button
      type="button"
      class="flex cursor-pointer items-center gap-1 rounded-full bg-primary/20 px-1.5 py-0.5 text-sm"
      (click)="removeGenre(genre)"
    >
      {{ genre | translate }}
      <span
        class="h-[16px] w-[16px] shrink-0 bg-current mask-[url(/assets/images/icons/close.svg)] mask-center mask-no-repeat mask-size-[10px_10px]"
        aria-hidden="true"
      ></span>
      <span class="sr-only">{{ "CLEAR_SEARCH" | translate }}</span>
    </button>
    } @for (year of releaseYearFilters; track year) {
    <button
      type="button"
      class="flex cursor-pointer items-center gap-1 rounded-full bg-primary/20 px-1.5 py-0.5 text-sm"
      (click)="removeReleaseYear(year)"
      [attr.aria-label]="'CATALOG_SEARCH_REMOVE_YEAR' | translate: {year}"
    >
      {{ "CATALOG_SEARCH_RELEASE_YEAR" | translate: {year} }}
      <span
        class="h-[16px] w-[16px] shrink-0 bg-current mask-[url(/assets/images/icons/close.svg)] mask-center mask-no-repeat mask-size-[10px_10px]"
        aria-hidden="true"
      ></span>
    </button>
    }
  </div>
  }
</div>
@if (hasSearch && works.length && displayedSearchTerm !== searchTerm) {
<p class="mb-1 text-sm text-grey dark:text-borders-dark" role="status">
  {{
    (isLoading ? "CATALOG_SEARCH_UPDATING" : "CATALOG_SEARCH_PREVIOUS_RESULTS")
      | translate
  }}
  @if (displayedSearchTerm) {
  {{ "CATALOG_SEARCH_RESULTS_FOR" | translate: {query: displayedSearchTerm} }} }
</p>
} @if (peopleEntities.length || collectionEntities.length) {
<div
  class="mt-1 grid shrink-0 gap-3"
  [ngClass]="{
    'tablet:grid-cols-2': peopleEntities.length && collectionEntities.length
  }"
>
  @if (peopleEntities.length) {
  <section
    class="min-w-0"
    [attr.aria-label]="'CATALOG_SEARCH_PEOPLE' | translate"
  >
    <app-entity-tags
      headingKey="CATALOG_SEARCH_PEOPLE"
      [isMobile]="isMobile"
      [entities]="peopleEntities"
      [selected]="selectedEntities"
      (toggled)="onEntityToggled($event)"
    />
  </section>
  } @if (collectionEntities.length) {
  <section
    class="min-w-0"
    [attr.aria-label]="'CATALOG_SEARCH_COLLECTIONS' | translate"
  >
    <app-entity-tags
      headingKey="CATALOG_SEARCH_COLLECTIONS"
      [isMobile]="isMobile"
      [entities]="collectionEntities"
      [selected]="selectedEntities"
      (toggled)="onEntityToggled($event)"
    />
  </section>
  }
</div>
} @if (!hasSearch && isOpen && user) {
<app-catalog-trending
  [works]="visibleWorks"
  [user]="user"
  [type]="searchType"
  [revision]="trendingRevision"
  [isMobile]="isMobile"
  [hasMultipleTypes]="!searchType"
  [modalNavigationContext]="modalNavigationContext"
  (worksLoaded)="works = $event"
/>
} @if (!hasSearch && isOpen && userResearch.length) {
<app-catalog-search-history
  [research]="userResearch"
  (researchSelected)="searchAgain($event)"
  (clearHistory)="deleteSearchHistory()"
/>} @if (hasSearch) {
<section
  class="shrink-0"
  [ngClass]="
    peopleEntities.length || collectionEntities.length
      ? 'mt-[36px] mobile:mt-[44px]'
      : 'mt-2'
  "
  [attr.aria-busy]="isLoading || loadingMore"
  aria-labelledby="search-results-heading"
>
  <div class="mb-2 flex min-w-0 flex-col gap-1">
    <h2
      id="search-results-heading"
      class="w-full min-w-0 break-words !m-0 !max-w-none !text-[18px] !leading-[24px] mobile:!text-[22px] mobile:!leading-[28px]"
    >
      {{ "CATALOG_SEARCH_RESULTS" | translate }}
    </h2>
    <div class="flex min-h-[32px] items-center justify-between gap-1">
      <span
        class="min-w-0 text-sm text-grey dark:text-borders-dark"
        aria-live="polite"
      >
        @if (!isLoading && !hasSearchError) { @if (countIsExact) {
        {{
          (count === 1
            ? "CATALOG_SEARCH_RESULT_COUNT_SINGLE"
            : "CATALOG_SEARCH_RESULT_COUNT"
          ) | translate: {count}
        }}
        } @else {
        {{ "CATALOG_SEARCH_RESULT_COUNT_LIMITED" | translate: {count} }}
        } } @else if (isLoading) {
        {{ "LOADING" | translate }}
        }
      </span>
      <div class="flex shrink-0 items-center gap-1">
        @if (selectedEntities.length) {
        <button
          type="button"
          appPointerHover
          class="flex min-h-[32px] shrink-0 cursor-pointer items-center justify-center gap-1 rounded-full bg-black/5 px-1.5 text-sm font-normal text-grey transition-colors [&.is-pointer-hovered]:bg-black/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-text dark:bg-white/5 dark:text-borders-dark dark:[&.is-pointer-hovered]:bg-white/10 dark:focus-visible:outline-primary"
          [attr.aria-label]="
            ('SORT' | translate) +
            ' : ' +
            (searchSortLabels[searchSort] | translate)
          "
          [cdkMenuTriggerFor]="searchSortMenu"
          [cdkMenuPosition]="[
            {
              originX: 'end',
              originY: 'bottom',
              overlayX: 'end',
              overlayY: 'top',
              offsetY: 8
            },
            {
              originX: 'end',
              originY: 'top',
              overlayX: 'end',
              overlayY: 'bottom',
              offsetY: -8
            }
          ]"
        >
          {{ "SORT" | translate }}
          <span
            class="h-0 w-0 shrink-0 border-x-[5px] border-t-[5px] border-x-transparent border-t-current"
            aria-hidden="true"
          ></span>
        </button>
        <ng-template #searchSortMenu>
          <div
            cdkMenu
            [attr.aria-label]="'SORT' | translate"
            class="w-[230px] max-w-[calc(100vw-32px)] overflow-hidden rounded-lg bg-whitegrey text-black drop-shadow-base dark:bg-black-dark-light dark:text-white"
          >
            @for (sort of searchSortOptions; track sort) {
            <button
              type="button"
              cdkMenuItemRadio
              appPointerHover
              class="block w-full cursor-pointer p-1 text-left font-base text-base font-normal [&.is-pointer-hovered]:bg-black/10 focus-visible:bg-black/10 focus-visible:outline-none dark:[&.is-pointer-hovered]:bg-white/10 dark:focus-visible:bg-white/10"
              [ngClass]="{'bg-black/10 dark:bg-white/10': searchSort === sort}"
              [cdkMenuItemChecked]="searchSort === sort"
              (cdkMenuItemTriggered)="changeSort(sort)"
            >
              {{ searchSortLabels[sort] | translate }}
            </button>
            }
          </div>
        </ng-template>
        }
        <button
          type="button"
          appPointerHover
          class="flex min-h-[32px] shrink-0 cursor-pointer items-center justify-center gap-0.75 rounded-full px-1.5 text-sm transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-text dark:focus-visible:outline-primary"
          [ngClass]="
            libraryOnly
              ? 'bg-primary/20 font-semibold text-black dark:text-white [&.is-pointer-hovered]:bg-primary/30'
              : 'bg-black/5 text-grey dark:bg-white/5 dark:text-borders-dark [&.is-pointer-hovered]:bg-black/10 dark:[&.is-pointer-hovered]:bg-white/10'
          "
          [attr.aria-pressed]="libraryOnly"
          (click)="toggleLibraryOnly()"
        >
          @if (libraryOnly) {
          <span
            class="h-[12px] w-[12px] shrink-0 bg-current mask-[url(/assets/images/icons/check.svg)] mask-center mask-no-repeat mask-size-[12px_12px]"
            aria-hidden="true"
          ></span>
          }
          {{ "MY_WORKS" | translate }}
        </button>
      </div>
    </div>
  </div>
  @if (searchType) {
  <app-catalog-beta-hint [type]="searchType" [compact]="true" /> } @if
  (isLoading && !works.length) {
  <div
    class="grid grid-cols-2 gap-5 sm:grid-cols-3 mobile:grid-cols-4 xl:grid-cols-5"
    [attr.aria-label]="'LOADING' | translate"
  >
    @for (placeholder of [1,2,3,4,5,6,7,8,9,10]; track placeholder) {
    <div class="animate-pulse">
      <div class="aspect-[2/3] rounded-lg bg-black/5 dark:bg-white/10"></div>
      <div class="mt-3 h-4 w-3/4 rounded bg-black/5 dark:bg-white/10"></div>
    </div>
    }
  </div>
  } @else if (user) { @let results = visibleWorks; @if (results.length) {
  <app-catalog-search-results
    [works]="results"
    [user]="user"
    [isMobile]="isMobile"
    [libraryOnly]="libraryOnly"
    [active]="isOpen"
    [scope]="searchCacheKey"
    [modalNavigationContext]="modalNavigationContext"
    [hasMultipleTypes]="!searchType"
    (workUpdated)="applyWorkUpdate($event)"
  />
  } @else if (!hasSearchError) {
  <p class="my-3 text-grey dark:text-borders-dark">
    {{
      (libraryOnly ? "CATALOG_SEARCH_LIBRARY_EMPTY" : "NOTHING_FOUND")
        | translate
    }}
  </p>
  @if (libraryOnly) {
  <button
    type="button"
    class="btn btn-transparent btn-small"
    (click)="toggleLibraryOnly()"
  >
    {{ "CATALOG_SEARCH_EXTEND_CATALOG" | translate }}
  </button>
  } } } @if (hasSearchError) {
  <div role="alert" class="my-5">
    <p class="mb-3">
      {{
        (isSearchUnavailable ? "SEARCH_UNAVAILABLE" : "ERROR_OCCURED_SEARCH")
          | translate
      }}
    </p>
    <button
      type="button"
      class="btn btn-transparent btn-small"
      (click)="retrySearch()"
    >
      {{ "CATALOG_ADD_SEARCH_RETRY" | translate }}
    </button>
  </div>
  } @else if (hasMore && !isLoading) {
  <div class="my-3 flex justify-center">
    <button
      type="button"
      class="btn btn-transparent btn-small"
      [disabled]="loadingMore"
      (click)="loadMore()"
    >
      {{ (loadingMore ? "LOADING" : "CATALOG_SEARCH_LOAD_MORE") | translate }}
    </button>
  </div>
  }
</section>
}
